import { render, staticRenderFns } from "./handpickSourceAdd.vue?vue&type=template&id=28bbcf08&scoped=true&"
import script from "./handpickSourceAdd.vue?vue&type=script&lang=js&"
export * from "./handpickSourceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bbcf08",
  null
  
)

export default component.exports